var _circle, _path, _circle2, _path2, _circle3, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Colored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 219.5,
    fill: "#fdd402"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbf13",
    d: "M96.5,256C96.5,144.95184,178.969,53.17993,286,38.5495A221.37921,221.37921,0,0,0,256,36.5C134.77344,36.5,36.5,134.7735,36.5,256S134.77344,475.5,256,475.5a221.37921,221.37921,0,0,0,30-2.0495C178.969,458.82007,96.5,367.04816,96.5,256Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 194.5,
    r: 28,
    fill: "#74563a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#674b34",
    d: "M157.5,194.5a28.00514,28.00514,0,0,1,18-26.15405,28,28,0,1,0,0,52.3081A28.00514,28.00514,0,0,1,157.5,194.5Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.5,
    cy: 194.5,
    r: 28,
    fill: "#74563a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#674b34",
    d: "M338.5,194.5a28.00478,28.00478,0,0,1,18-26.15405,28,28,0,1,0,0,52.3081A28.00478,28.00478,0,0,1,338.5,194.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#74563a",
    d: "M350.5752,379.58643a7.50111,7.50111,0,0,1-6.80079-4.32959A118.3802,118.3802,0,0,0,305.09668,328.919a117.19109,117.19109,0,0,0-39.4541-18.20459,115.96118,115.96118,0,0,0-48.26563-1.78223l-6.89648,1.189a115.94082,115.94082,0,0,0-44.8916,17.83936,7.5001,7.5001,0,0,1-8.31836-12.48242,130.86558,130.86558,0,0,1,50.66113-20.13916l6.89649-1.189a131.79347,131.79347,0,0,1,98.9541,22.53955,133.40323,133.40323,0,0,1,43.584,52.22266,7.50428,7.50428,0,0,1-6.791,10.67432Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Colored);
export default __webpack_public_path__ + "static/media/3-colored.ea40f4e34eddd70034ea13bb9e4df263.svg";
export { ForwardRef as ReactComponent };